import { Button } from "@/components/ui/button";
import { useModulePermissions } from "@/modules/account/hooks/useModulePermissions";
import { Plus } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useCheckIsProjectLocked } from "@/modules/projects/hooks/useCheckIsProjectLocked";

interface ContractorsAssignmentsAddButtonProps {
  onClick: () => void;
}

export const ContractorsAssignmentsAddButton = ({
  onClick,
}: ContractorsAssignmentsAddButtonProps) => {
  const { t } = useTranslation();
  const { can_create } = useModulePermissions();
  const isProjectLocked = useCheckIsProjectLocked();

  return (
    <Button
      variant="outline"
      onClick={onClick}
      disabled={!can_create || isProjectLocked}
    >
      <Plus className="w-4 h-4 mr-2" />
      {t("contractorsAssignments.addRow")}
    </Button>
  );
};
